import { render, staticRenderFns } from "./pieChartSetup.vue?vue&type=template&id=0480fce8&scoped=true&"
import script from "./pieChartSetup.vue?vue&type=script&lang=js&"
export * from "./pieChartSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480fce8",
  null
  
)

export default component.exports